// extracted by mini-css-extract-plugin
export var closeButton = "_94-0";